/**
 * Meal ideas and their groups from meal_idea/index's shape (or the food snapshot's, which is the
 * same), keyed by id. Kept apart from the mealIdeas reducer, which re-exports it, so the food store
 * can use it without importing the reducer's actions and, through them, the store itself.
 *
 * Ids arrive as whatever the server sent; everything here compares them as numbers.
 */
export function normalizeIndex(payload) {
	const ideasById = {};
	(payload.ideas || []).forEach((idea) => {
		const id = Number(idea.id);
		ideasById[id] = {
			...idea,
			id,
			ingredients: (idea.ingredients || []).map((ingredient) => ({ ...ingredient, id: Number(ingredient.id) })),
		};
	});

	const groups = (payload.groups || []).map((group) => ({
		...group,
		id: Number(group.id),
		order: Number(group.order || 0),
		meal_idea_ids: (group.meal_idea_ids || []).map(Number).filter((id) => ideasById[id]),
	}));
	groups.sort((a, b) => (a.order - b.order) || String(a.name).localeCompare(String(b.name)));

	const groupsById = {};
	groups.forEach((group) => {
		groupsById[group.id] = group;
	});

	return { ideasById, groupsById, groupOrder: groups.map((group) => group.id) };
}
